(function () {
  const modal = document.getElementById("global-e-localization-modal");
  const dataElement = document.getElementById("global-e-localization-data");

  if (!modal || !dataElement) return;

  const data = JSON.parse(dataElement.textContent || "{}");
  const countries = Array.isArray(data.countries) ? data.countries : [];
  if (!countries.length) return;

  const stages = {
    redirect: modal.querySelector('[data-ge-stage="redirect"]'),
    selector: modal.querySelector('[data-ge-stage="selector"]'),
    international: modal.querySelector('[data-ge-stage="international"]'),
    success: modal.querySelector('[data-ge-stage="success"]')
  };

  const ui = {
    redirectHeading: modal.querySelector("[data-ge-redirect-heading]"),
    redirectCopy: modal.querySelector("[data-ge-redirect-copy]"),
    redirectPrimary: modal.querySelector("[data-ge-redirect-primary]"),
    redirectSecondary: modal.querySelector("[data-ge-redirect-secondary]"),
    selectorSearch: modal.querySelector("[data-ge-selector-search]"),
    selectorResults: modal.querySelector("[data-ge-selector-results]"),
    selectorToggle: modal.querySelector("[data-ge-selector-toggle]"),
    selectorClear: modal.querySelector("[data-ge-selector-clear]"),
    internationalSearch: modal.querySelector("[data-ge-international-search]"),
    internationalResults: modal.querySelector("[data-ge-international-results]"),
    internationalToggle: modal.querySelector("[data-ge-international-toggle]"),
    internationalClear: modal.querySelector("[data-ge-international-clear]"),
    currencyField: modal.querySelector("[data-ge-currency-field]"),
    internationalSave: modal.querySelector("[data-ge-international-save]"),
    successClose: modal.querySelector("[data-ge-success-close]"),
    triggers: document.querySelectorAll("[data-global-e-localization-trigger]")
  };

  const SUCCESS_PARAM = "geLocalizationSaved";
  const DISMISSED_COOKIE = "ge_localization_dismissed";
  const SELECTED_COUNTRY_STORAGE_KEY = "ge_localization_selected_country";
  const SET_COUNTRY_QUERY_KEY = "geSetCountry";
  const DISMISS_DAYS = 30;

  const isCaStore = typeof data.isCaStore === "boolean"
    ? data.isCaStore
    : window.location.hostname.indexOf(".ca") > -1;
  const defaultCountry = isCaStore ? "CA" : "US";

  const priorityCountryOrder = isCaStore
    ? ["CA", "US", "GB", "AU", "JP"]
    : ["US", "CA", "GB", "AU", "JP"];
  const priorityRank = priorityCountryOrder.reduce((acc, code, index) => {
    acc[code] = index;
    return acc;
  }, {});

  countries.sort((a, b) => {
    const aCode = String(a.isoCode || "").toUpperCase();
    const bCode = String(b.isoCode || "").toUpperCase();
    const aRank = Object.prototype.hasOwnProperty.call(priorityRank, aCode) ? priorityRank[aCode] : Infinity;
    const bRank = Object.prototype.hasOwnProperty.call(priorityRank, bCode) ? priorityRank[bCode] : Infinity;

    if (aRank !== bRank) return aRank - bRank;

    return String(a.name || "").localeCompare(String(b.name || ""), undefined, { sensitivity: "base" });
  });

  const countriesByCode = countries.reduce((acc, country) => {
    acc[country.isoCode] = country;
    return acc;
  }, {});
  const storeLockedCountry = isCaStore ? "CA" : "";

  let autoPopupOpened = false;
  let selectedInternationalCountry = null;
  let redirectContext = null;

  const redirectModes = {
    "ca-on-com": {
      heading: "Shopping from <em>Canada</em>?",
      copy: "For the best experience and free shipping over $100, let’s take you to the right place.",
      primaryLabel: "Go to Canada Site",
      primaryAction: () => redirectToDomain(data.caDomain),
      secondaryLabel: "Choose Shipping Destination",
      secondaryAction: () => openSelector()
    },
    "us-on-ca": {
      heading: "Shopping from <em>USA</em>?",
      copy: "For the best experience and free shipping over $100, let’s take you to the right place.",
      primaryLabel: "Go to USA Site",
      primaryAction: () => redirectToComWithCountry("US"),
      secondaryLabel: "Choose Shipping Destination",
      secondaryAction: () => openSelector()
    }
  };

  function toCountryCode(value) {
    return String(value || "").trim().toUpperCase();
  }

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax; Secure`;
  }

  function getCookie(name) {
    const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : "";
  }

  function sanitizeUrl(url) {
    url.searchParams.delete(SUCCESS_PARAM);
    url.searchParams.delete(SET_COUNTRY_QUERY_KEY);
    return url;
  }

  function currentPathAndQuery(extraParams = {}) {
    const url = sanitizeUrl(new URL(window.location.href));

    Object.entries(extraParams).forEach(([key, value]) => {
      if (value === null || value === "") {
        url.searchParams.delete(key);
      } else {
        url.searchParams.set(key, value);
      }
    });

    return `${url.pathname}${url.search}`;
  }

  function updateHistoryUrl(url) {
    window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
  }

  function flagEmoji(countryCode) {
    if (!countryCode || countryCode.length !== 2) return "";
    return String.fromCodePoint(...countryCode.toUpperCase().split("").map((char) => 127397 + char.charCodeAt(0)));
  }

  function currencyLabel(country) {
    if (!country) return "";

    if (!isCaStore && country.isoCode === "CA") {
      return "CAD $";
    }

    if (country.currencySymbol && country.currencySymbol !== country.currencyIso) {
      return `${country.currencyIso} ${country.currencySymbol}`;
    }
    return country.currencyIso || "";
  }

  function findCountry(code) {
    return countriesByCode[code] || countriesByCode[defaultCountry] || countries[0];
  }

  function countryDisplayLabel(country, options = {}) {
    if (!country) return "";
    if (options.includeCurrency === false) return country.name;
    return `${country.name} (${currencyLabel(country)})`;
  }

  function normalizeCountryForStore(countryCode) {
    if (storeLockedCountry) return storeLockedCountry;
    const normalized = toCountryCode(countryCode);
    if (!isCaStore && normalized === "CA") return "US";
    return normalized;
  }

  function isInternationalComCountry(countryCode) {
    const normalized = toCountryCode(countryCode);
    return !isCaStore && normalized && normalized !== "US" && normalized !== "CA";
  }

  function toggleInternationalPdpContent(countryCode) {
    const shouldHide = isInternationalComCountry(countryCode);
    document.documentElement.classList.toggle("ge-international-selected", shouldHide);
    document.querySelectorAll("[data-ge-international-hide]").forEach((block) => {
      block.classList.toggle("ge-hide-display-none", shouldHide);
    });
  }

  function watchInternationalPdpContent() {
    if (!("MutationObserver" in window)) return;

    const observer = new MutationObserver(() => {
      toggleInternationalPdpContent(getInitialSelectedCountry());
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function getStoredSelectedCountry() {
    return toCountryCode(localStorage.getItem(SELECTED_COUNTRY_STORAGE_KEY));
  }

  function getLocalizedCountry() {
    return toCountryCode(data.currentCountry);
  }

  function commitSelectedCountry(countryCode) {
    const normalized = normalizeCountryForStore(countryCode);
    if (!normalized || !countriesByCode[normalized]) return;
    localStorage.setItem(SELECTED_COUNTRY_STORAGE_KEY, normalized);
    updateTriggers(normalized);
    toggleInternationalPdpContent(normalized);
  }

  function updateTriggers(countryCode) {
    const country = findCountry(normalizeCountryForStore(countryCode));
    const emoji = flagEmoji(country.isoCode);
    const label = currencyLabel(country);

    ui.triggers.forEach((trigger) => {
      const emojiNode = trigger.querySelector("[data-ge-trigger-emoji]");
      const labelNode = trigger.querySelector("[data-ge-trigger-label]");
      if (emojiNode) emojiNode.textContent = emoji;
      if (labelNode) labelNode.textContent = label;
    });
  }

  function getInitialSelectedCountry() {
    if (storeLockedCountry) return storeLockedCountry;

    const storedCountry = getStoredSelectedCountry();
    if (storedCountry && countriesByCode[storedCountry]) return storedCountry;

    const liquidCountry = getLocalizedCountry();
    if (liquidCountry && countriesByCode[liquidCountry]) return liquidCountry;

    return defaultCountry;
  }

  function setStage(stageName) {
    Object.entries(stages).forEach(([name, node]) => {
      if (!node) return;
      node.hidden = name !== stageName;
    });
  }

  function setDropdownState(searchInput, toggleButton, resultsNode, isOpen) {
    const wrapper = searchInput?.closest(".ge-localization__search-wrapper");
    if (resultsNode) resultsNode.hidden = !isOpen;
    wrapper?.classList.toggle("is-open", isOpen);
    if (toggleButton) toggleButton.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function closeDropdown(resultsNode, searchInput, toggleButton) {
    setDropdownState(searchInput, toggleButton, resultsNode, false);
  }

  function openDropdown(resultsNode, searchInput, toggleButton) {
    setDropdownState(searchInput, toggleButton, resultsNode, true);
  }

  function dropdownIsOpen(resultsNode) {
    return Boolean(resultsNode) && !resultsNode.hidden;
  }

  function updateClearButton(searchInput, clearButton) {
    if (!clearButton) return;
    clearButton.hidden = !(searchInput && searchInput.value);
  }

  function dismissAutoPopupIfNeeded() {
    if (!autoPopupOpened) return;
    setCookie(DISMISSED_COOKIE, "1", DISMISS_DAYS);
    autoPopupOpened = false;
  }

  function closeModal() {
    dismissAutoPopupIfNeeded();
    closeDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
    closeDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
    modal.hide();
  }

  function openModal(stageName) {
    setStage(stageName);
    modal.show();
  }

  async function maybeCloseMobileSidebar(triggerElement) {
    if (triggerElement?.dataset?.geTriggerContext !== "mobile-nav") return;

    const sidebar = document.getElementById("sidebar-menu");
    if (!sidebar || !sidebar.open) return;

    if (typeof sidebar.hide === "function") {
      await sidebar.hide();
      return;
    }

    sidebar.open = false;
  }

  function getInternationalDefaultCurrencyLabel() {
    if (isCaStore) return "";
    return currencyLabel(findCountry("US"));
  }

  function openSelector() {
    ui.selectorSearch.value = "";
    ui.selectorSearch.dataset.selectedLabel = "";
    ui.selectorResults.innerHTML = "";
    updateClearButton(ui.selectorSearch, ui.selectorClear);
    closeDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
    openModal("selector");
  }

  function openInternational() {
    selectedInternationalCountry = null;
    ui.internationalSearch.value = "";
    ui.internationalSearch.dataset.selectedLabel = "";
    if (ui.currencyField) ui.currencyField.value = getInternationalDefaultCurrencyLabel();
    ui.internationalResults.innerHTML = "";
    ui.internationalSave.disabled = true;
    updateClearButton(ui.internationalSearch, ui.internationalClear);
    closeDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
    openModal("international");
  }

  function redirectToDomain(origin) {
    window.location.assign(`${origin}${currentPathAndQuery()}`);
  }

  function redirectToComWithCountry(countryCode, options = {}) {
    const showSuccess = options.showSuccess === true;
    const url = sanitizeUrl(new URL(window.location.href));
    url.searchParams.set(SET_COUNTRY_QUERY_KEY, countryCode);
    if (showSuccess) {
      url.searchParams.set(SUCCESS_PARAM, "1");
    }
    window.location.assign(`${data.comDomain}${url.pathname}${url.search}`);
  }

  function submitLocalization(countryCode, origin, options = {}) {
    const showSuccess = options.showSuccess === true;
    const languageCode = String(data.currentLanguageIso || "en").trim().toLowerCase();
    const form = document.createElement("form");
    const returnTo = currentPathAndQuery(showSuccess ? { [SUCCESS_PARAM]: "1" } : {});
    const fields = {
      _method: "PUT",
      country_code: countryCode,
      language_code: languageCode,
      return_to: returnTo
    };

    if (showSuccess) {
      setCookie(DISMISSED_COOKIE, "1", DISMISS_DAYS);
      autoPopupOpened = false;
    }

    form.method = "POST";
    form.action = `${origin}/localization`;
    form.hidden = true;

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  function applyInternationalSelection(countryCode) {
    const selectedCountry = findCountry(countryCode);
    if (!selectedCountry) return;

    selectedInternationalCountry = countryCode;
    const selectedLabel = countryDisplayLabel(selectedCountry, { includeCurrency: !isCaStore });
    ui.internationalSearch.value = selectedLabel;
    ui.internationalSearch.dataset.selectedLabel = selectedLabel;
    if (ui.currencyField) ui.currencyField.value = currencyLabel(selectedCountry);
    ui.internationalSave.disabled = false;
    updateClearButton(ui.internationalSearch, ui.internationalClear);
    closeDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
  }

  function handleCountrySelection(countryCode, source) {
    const selectedCountry = findCountry(countryCode);
    if (!selectedCountry) return;

    if (countryCode === "CA") {
      commitSelectedCountry(countryCode);
      if (isCaStore) {
        submitLocalization(countryCode, data.caDomain);
      } else {
        redirectToDomain(data.caDomain);
      }
      return;
    }

    if (countryCode === "US") {
      commitSelectedCountry(countryCode);
      if (isCaStore) {
        redirectToComWithCountry(countryCode);
      } else {
        submitLocalization(countryCode, data.comDomain);
      }
      return;
    }

    if (source === "international") {
      applyInternationalSelection(countryCode);
      return;
    }

    commitSelectedCountry(countryCode);
    if (isCaStore) {
      redirectToComWithCountry(countryCode, { showSuccess: true });
    } else {
      submitLocalization(countryCode, data.comDomain, { showSuccess: true });
    }
  }

  function renderOptions(resultsNode, searchValue, onSelect, selectedCode, options = {}) {
    if (!resultsNode) return;

    const includeCurrency = options.includeCurrency !== false;
    const query = searchValue.trim().toLowerCase();
    const normalizedSelectedLabel = selectedCode && countriesByCode[selectedCode]
      ? countryDisplayLabel(findCountry(selectedCode), { includeCurrency }).trim().toLowerCase()
      : "";

    const matches = countries.filter((country) => {
      if (normalizedSelectedLabel && query === normalizedSelectedLabel) {
        return country.isoCode === selectedCode;
      }
      if (query.length === 0) return true;
      return country.name.toLowerCase().includes(query) || country.currencyIso.toLowerCase().includes(query);
    });

    if (matches.length === 0) {
      resultsNode.innerHTML = '<div class="ge-localization__empty">No countries found.</div>';
      return;
    }

    resultsNode.innerHTML = matches.map((country) => {
      const selectedClass = selectedCode && country.isoCode === selectedCode ? " is-selected" : "";
      return `<button type="button" class="ge-localization__option${selectedClass}" data-ge-country-option="${country.isoCode}">${countryDisplayLabel(country, { includeCurrency })}</button>`;
    }).join("");

    resultsNode.querySelectorAll("[data-ge-country-option]").forEach((button) => {
      button.addEventListener("click", () => onSelect(button.getAttribute("data-ge-country-option")));
    });
  }

  function renderSelectorOptions(searchValue) {
    renderOptions(
      ui.selectorResults,
      searchValue,
      (countryCode) => handleCountrySelection(countryCode, "selector"),
      null,
      { includeCurrency: !isCaStore }
    );
  }

  function renderInternationalOptions(searchValue) {
    renderOptions(
      ui.internationalResults,
      searchValue,
      (countryCode) => handleCountrySelection(countryCode, "international"),
      selectedInternationalCountry,
      { includeCurrency: !isCaStore }
    );
  }

  function openSelectorDropdownWithAllOptions() {
    renderSelectorOptions("");
    openDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
  }

  function openInternationalDropdownWithAllOptions() {
    renderInternationalOptions("");
    openDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
  }

  function configureRedirect(contextName) {
    redirectContext = redirectModes[contextName];
    if (!redirectContext) return;

    ui.redirectHeading.innerHTML = redirectContext.heading;
    ui.redirectCopy.textContent = redirectContext.copy;
    ui.redirectPrimary.textContent = redirectContext.primaryLabel;
    ui.redirectSecondary.textContent = redirectContext.secondaryLabel;
  }

  async function detectVisitorCountry() {
    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`, {
        credentials: "same-origin"
      });
      if (!response.ok) return "";

      const payload = await response.json();
      return toCountryCode(
        payload?.detected_values?.country?.handle ||
        payload?.suggested_values?.country?.handle ||
        payload?.detected_values?.country?.iso_code
      );
    } catch (error) {
      return "";
    }
  }

  function maybeApplyCountryFromQuery() {
    const url = new URL(window.location.href);
    const requestedCountry = toCountryCode(url.searchParams.get(SET_COUNTRY_QUERY_KEY));
    if (!requestedCountry || !countriesByCode[requestedCountry]) return false;

    const currentCountry = toCountryCode(data.currentCountry);
    const shouldShowSuccess = url.searchParams.get(SUCCESS_PARAM) === "1";

    if (currentCountry === requestedCountry) {
      commitSelectedCountry(requestedCountry);
      setCookie(DISMISSED_COOKIE, "1", DISMISS_DAYS);
      url.searchParams.delete(SET_COUNTRY_QUERY_KEY);
      updateHistoryUrl(url);
      return false;
    }

    commitSelectedCountry(requestedCountry);
    submitLocalization(requestedCountry, data.comDomain, { showSuccess: shouldShowSuccess });
    return true;
  }

  function maybeShowSuccessState() {
    const url = new URL(window.location.href);
    if (url.searchParams.get(SUCCESS_PARAM) !== "1") return false;

    setCookie(DISMISSED_COOKIE, "1", DISMISS_DAYS);
    url.searchParams.delete(SUCCESS_PARAM);
    updateHistoryUrl(url);
    autoPopupOpened = false;
    openModal("success");
    return true;
  }

  async function maybeShowAutoPopup() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (maybeApplyCountryFromQuery()) return;
    if (maybeShowSuccessState()) return;

    const detectedCountry = await detectVisitorCountry();
    if (!detectedCountry) return;

    if (getCookie(DISMISSED_COOKIE)) return;

    autoPopupOpened = true;

    if (!isCaStore && detectedCountry === "CA") {
      configureRedirect("ca-on-com");
      openModal("redirect");
      return;
    }

    if (isCaStore && detectedCountry === "US") {
      configureRedirect("us-on-ca");
      openModal("redirect");
      return;
    }

    if (!isCaStore && detectedCountry !== "US" && detectedCountry !== "CA") {
      openInternational();
      return;
    }

    if (isCaStore && detectedCountry !== "CA" && detectedCountry !== "US") {
      openInternational();
    }
  }

  ui.redirectPrimary?.addEventListener("click", () => {
    dismissAutoPopupIfNeeded();
    if (redirectContext) redirectContext.primaryAction();
  });

  ui.redirectSecondary?.addEventListener("click", () => {
    dismissAutoPopupIfNeeded();
    if (redirectContext) redirectContext.secondaryAction();
  });

  ui.selectorSearch?.addEventListener("click", () => openSelectorDropdownWithAllOptions());
  ui.selectorSearch?.addEventListener("input", () => {
    updateClearButton(ui.selectorSearch, ui.selectorClear);
    renderSelectorOptions(ui.selectorSearch.value);
    openDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
  });

  ui.selectorToggle?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (dropdownIsOpen(ui.selectorResults)) {
      closeDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
    } else {
      openSelectorDropdownWithAllOptions();
    }
  });

  ui.internationalSearch?.addEventListener("click", () => openInternationalDropdownWithAllOptions());
  ui.internationalSearch?.addEventListener("input", () => {
    updateClearButton(ui.internationalSearch, ui.internationalClear);
    renderInternationalOptions(ui.internationalSearch.value);
    openDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
  });

  ui.internationalToggle?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (dropdownIsOpen(ui.internationalResults)) {
      closeDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
    } else {
      openInternationalDropdownWithAllOptions();
    }
  });

  ui.internationalSave?.addEventListener("click", () => {
    if (!selectedInternationalCountry) return;

    if (selectedInternationalCountry === "CA" || selectedInternationalCountry === "US") {
      handleCountrySelection(selectedInternationalCountry, "selector");
      return;
    }

    commitSelectedCountry(selectedInternationalCountry);
    if (isCaStore) {
      redirectToComWithCountry(selectedInternationalCountry, { showSuccess: true });
    } else {
      submitLocalization(selectedInternationalCountry, data.comDomain, { showSuccess: true });
    }
  });

  ui.selectorClear?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    ui.selectorSearch.value = "";
    ui.selectorSearch.dataset.selectedLabel = "";
    updateClearButton(ui.selectorSearch, ui.selectorClear);
    renderSelectorOptions("");
    openDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
    ui.selectorSearch.focus();
  });

  ui.internationalClear?.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    selectedInternationalCountry = null;
    ui.internationalSearch.value = "";
    ui.internationalSearch.dataset.selectedLabel = "";
    if (ui.currencyField) ui.currencyField.value = getInternationalDefaultCurrencyLabel();
    ui.internationalSave.disabled = true;
    updateClearButton(ui.internationalSearch, ui.internationalClear);
    renderInternationalOptions("");
    openDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
    ui.internationalSearch.focus();
  });

  ui.successClose?.addEventListener("click", () => closeModal());

  ui.triggers.forEach((trigger) => {
    trigger.addEventListener("click", async () => {
      autoPopupOpened = false;
      await maybeCloseMobileSidebar(trigger);
      openSelector();
    });
  });

  modal.addEventListener("dialog:after-hide", () => {
    dismissAutoPopupIfNeeded();
  });

  document.addEventListener("click", (event) => {
    if (modal.contains(event.target)) return;
    closeDropdown(ui.selectorResults, ui.selectorSearch, ui.selectorToggle);
    closeDropdown(ui.internationalResults, ui.internationalSearch, ui.internationalToggle);
  });

  window.addEventListener("pageshow", () => {
    if (!storeLockedCountry) return;
    commitSelectedCountry(storeLockedCountry);
  });

  commitSelectedCountry(getInitialSelectedCountry());
  watchInternationalPdpContent();
  updateClearButton(ui.selectorSearch, ui.selectorClear);
  updateClearButton(ui.internationalSearch, ui.internationalClear);
  maybeShowAutoPopup();
})();
